import {logConstants} from "../constants/log.constants";

const initState = {
    contentActivityList: null,
};

export function logReducer(state = initState, action) {
    switch (action.type) {
        case logConstants.CONTENT_ACTIVITY_LIST_REQUEST:
        case logConstants.CONTENT_ACTIVITY_LIST_FAILURE:
            return  {
                contentActivityList: null
            };
        case logConstants.CONTENT_ACTIVITY_LIST_SUCCESS:
            return {
                ...state,
                contentActivityList: action.activityList
            };
        default:
            return state
    }
}
